import { tap, switchMap } from 'rxjs';
import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EVENT_BUS } from 'src/app/shared/domain/tokens/event-bus.token';
import { CALENDAR_EVENT_SERVICE } from 'src/app/shared/calendar-event/token/calendar-event.token';
import { InitialDataDoneEvent} from 'src/app/shared/application/events/data-loader/initial-data-done.event';
import { CONSUMPTION_STORE } from '../../domain/tokens/consumption.token';

@Injectable({ providedIn: 'root' })
export class ConsumptionStoreSubscriber {
  private readonly consumptionStoreService = inject(CONSUMPTION_STORE);
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);
  private readonly calendarEventService = inject(CALENDAR_EVENT_SERVICE);

  constructor() {
    this.eventBus.ofType(InitialDataDoneEvent).pipe(
      switchMap((event) => this.calendarEventService.getCalendarEventByIdFromServer(event.serviceId ?? '')),
      tap(event => {
        if (event) {
          this.consumptionStoreService.setCalendarEvent(event);
        } else {
          this.consumptionStoreService.clearCalendarEvent();
        }
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe();
  }
}